import { render, staticRenderFns } from "./HostCard.vue?vue&type=template&id=773c9cc2&scoped=true"
import script from "./HostCard.vue?vue&type=script&lang=js"
export * from "./HostCard.vue?vue&type=script&lang=js"
import style0 from "./HostCard.vue?vue&type=style&index=0&id=773c9cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773c9cc2",
  null
  
)

export default component.exports